import { defineComponent as _defineComponent } from 'vue'
import { useDelStakeholderMutation } from '~/types/types'

export default /*#__PURE__*/_defineComponent({
  __name: 'DelStakeholder',
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  item: any
};



const { mutate: del, loading: delLoading } = useDelStakeholderMutation()

return { __sfc: true,props, del, delLoading }
}

})